// extracted by mini-css-extract-plugin
module.exports = {"log":"logs_log__1zTDe"};